<!-- version 2021/05/20 -->
<template>
  <textarea
    ref="textarea"
    v-model="textValue"
    :placeholder="placeholder"
    :name="name"
    :maxlength="maxlength"
  />
</template>

<script>
export default {
  events: {
    change: "change",
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    maxcols: {
      type: Number,
      default: 0,
    },
    maxrows: {
      type: Number,
      default: 0,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    autoresize: {
      type: Boolean,
      default: false,
    },
    minheight: {
      type: Number,
      default: null,
    },
    maxheight: {
      type: Number,
      default: null,
    },
    customData: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      textValue: this.text,
      prevTextValue: this.text,
      minheightValue: null,
    };
  },
  watch: {
    textValue(val) {
      if (this.setValue(val)) {
        this.$emit('update', this, val, this.customData);
        this.applyAutoresize();
      }
    }
  },
  mounted() {
    this.minheightValue = this.minheight;
    if (this.minheightValue == null) {
      this.minheightValue = this.$refs.textarea.offsetHeight;
    }

    this.$nextTick(() => {
      this.applyAutoresize();
    });
  },
  methods: {
    setValue(value) {
      // 行数のチェック
      if (this.maxrows > 0) {
        if (value.split("\n").length > this.maxrows) {
          this.textValue = this.prevTextValue;
          return false;
        }
      }
      // 列数チェック
      if (this.maxcols > 0) {
        const lines = value.split("\n");
        const overMaxCols = lines.find((text) => (text.length > this.maxcols));
        if (overMaxCols) {
          // Textの内容を戻したときに、カーソル位置が移動してしまうことがあるため、
          // カーソル位置をもとに戻す

          // 文字を入力した場合と、削除した場合でカーソルの位置が変わるため調整
          const isDelete = this.prevTextValue.length > value.length;

          const cursorPos = this.$refs.textarea.selectionStart + (isDelete ? 0 : -1);
          this.textValue = this.prevTextValue;
          this.$nextTick(() => {
            this.$refs.textarea.setSelectionRange(cursorPos, cursorPos);
          });
          return false;
        }
      }

      this.prevTextValue = value;
      return true;
    },
    applyAutoresize() {
      if (!this.autoresize) return;

      const elem = this.$refs.textarea;
      if (elem.offsetHeight > elem.scrollHeight) {
        elem.style.height = this.minheightValue + 'px';
      }

      const diff = elem.scrollHeight - elem.offsetHeight;
      if (diff > 0) {
        let newSize = (elem.offsetHeight + diff + 10);
        if (this.maxheight && newSize > this.maxheight) {
          newSize = this.maxheight;
        }
        elem.style.height = newSize + 'px';
      }
    }
  },
};
</script>

<style lang="sass" scoped>
textarea
  padding: 0.375rem 0.75rem
  font-size: 1rem
  color: #495057
  border: 1px solid #ced4da
  border-radius: 0.25rem
</style>
